import React, { useEffect, useState } from "react";
import { Dropdown } from "react-bootstrap";
import { Link } from "react-router-dom";
import { Trans } from "react-i18next";
import { FaUser } from "react-icons/fa";
import { apiRequest } from "../apiServices/allApi";

function Navbar(props) {
  const [installPrompt, setInstallPrompt] = useState(null);
  const [isInstalled, setIsInstalled] = useState(() =>
    window.matchMedia?.("(display-mode: standalone)").matches ||
    window.navigator.standalone === true,
  );

  useEffect(() => {
    const handleBeforeInstallPrompt = (event) => {
      event.preventDefault();
      setInstallPrompt(event);
    };
    const handleAppInstalled = () => {
      setIsInstalled(true);
      setInstallPrompt(null);
    };

    window.addEventListener("beforeinstallprompt", handleBeforeInstallPrompt);
    window.addEventListener("appinstalled", handleAppInstalled);
    return () => {
      window.removeEventListener("beforeinstallprompt", handleBeforeInstallPrompt);
      window.removeEventListener("appinstalled", handleAppInstalled);
    };
  }, []);

  const downloadApp = async () => {
    if (installPrompt) {
      await installPrompt.prompt();
      const { outcome } = await installPrompt.userChoice;
      if (outcome === "accepted") setIsInstalled(true);
      setInstallPrompt(null);
      return;
    }

    if (isInstalled) return;

    const isIOS = /iphone|ipad|ipod/i.test(window.navigator.userAgent);
    window.alert(
      isIOS
        ? "To install the admin app, tap Share in Safari, then choose Add to Home Screen."
        : "App installation is not available in this browser yet. Open this site in Chrome or Edge over HTTPS and try again.",
    );
  };

  const logout = async () => {
    const access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };

    try {
      await apiRequest(`logout`, "POST", null, headers);
    } catch (e) {
    } finally {
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      localStorage.removeItem("id");
      localStorage.removeItem("updateLegalData");
      window.location.assign("/adminlogin");
    }
  };

  const toggleOffcanvas = () => {
    document.querySelector(".sidebar-offcanvas").classList.toggle("active");
  };

  return (
    <nav className="navbar p-0 fixed-top d-flex flex-row">
      <div className="navbar-brand-wrapper d-flex d-lg-none align-items-center justify-content-center">
        <Link className="navbar-brand brand-logo-mini" to="/">
          <img src="/logo.png" alt="logo" />
        </Link>
      </div>
      <div className="navbar-menu-wrapper flex-grow d-flex align-items-stretch">
        <button
          className="navbar-toggler align-self-center"
          type="button"
          onClick={() => document.body.classList.toggle("sidebar-icon-only")}
        >
          <span className="mdi mdi-menu toggle_btn"></span>
        </button>
        <ul className="navbar-nav w-100">
          <li className="nav-item w-100"></li>
        </ul>

        <ul className="navbar-nav navbar-nav-right">
          <Dropdown alignRight as="li" className="nav-item">
            <Dropdown.Toggle
              as="a"
              className="nav-link cursor-pointer no-caret"
            >
              <div className="navbar-profile">
                <FaUser style={{ fontSize: "20px" }} />
                <p className="mb-0 d-none d-sm-block navbar-profile-name">
                  <Trans>User: {props.usertype}</Trans>
                </p>
                <i className="mdi mdi-menu-down d-none d-sm-block text-dark"></i>
              </div>
            </Dropdown.Toggle>

            <Dropdown.Menu className="navbar-dropdown preview-list navbar-profile-dropdown-menu shadow-lg border-0">
             
              <Dropdown.Divider />
              {/* <Dropdown.Item className="preview-item">
                <Link to={"/admin/update"} className="preview-thumbnail">
                  <div className="preview-icon bg-primary-subtle text-primary rounded-circle">
                    <i className="mdi mdi-update text-primary"></i>
                  </div>
                </Link>
                <Link to={"/admin/update"} className="preview-item-content">
                  <p className="preview-subject mb-1 text-dark">
                    <Trans>Update Password</Trans>
                  </p>
                </Link>
              </Dropdown.Item> */}
              {!isInstalled && (
                <Dropdown.Item onClick={downloadApp} className="preview-item">
                  <div className="preview-thumbnail">
                    <div className="preview-icon bg-success-subtle text-success rounded-circle">
                      <i className="mdi mdi-download text-success"></i>
                    </div>
                  </div>
                  <div className="preview-item-content">
                    <p className="preview-subject mb-1 text-dark">
                      <Trans>Download App</Trans>
                    </p>
                  </div>
                </Dropdown.Item>
              )}
              <Dropdown.Divider />
              <Dropdown.Item
                onClick={() => logout()}
                className="preview-item"
              >
                <div className="preview-thumbnail">
                  <div className="preview-icon bg-danger-subtle text-danger rounded-circle">
                    <i className="mdi mdi-logout text-danger"></i>
                  </div>
                </div>
                <div className="preview-item-content">
                  <p className="preview-subject mb-1 text-dark">
                    <Trans>Log Out</Trans>
                  </p>
                </div>
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </ul>
        <button
          className="navbar-toggler navbar-toggler-right d-lg-none align-self-center"
          type="button"
          onClick={toggleOffcanvas}
        >
          <span className="mdi mdi-menu toggle_btn"></span>
        </button>
      </div>
    </nav>
  );
}

export default Navbar;
